import { render, staticRenderFns } from "./cahierParent.vue?vue&type=template&id=4737b97c&"
import script from "./cahierParent.vue?vue&type=script&lang=js&"
export * from "./cahierParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports